import React from "react";
import { postData } from "../../../../../../api/componentAPIs";
import CustomConfirmationDialog from "../../../../Dispatch/RouteExecution/DriverPopUp/common/CustomConfirmationDialog";

function DeleteDialog(props) {
  const deleteTerminal = () => {
    const requestParams = {
      userTerminal: props.terminalCode,
      terminalCode: props.selectedTerminal,
      accessibleTerminals: [],
    };
    postData(props.updateAPI, requestParams).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          props.enqueueSnackbar(`Deleted terminal ${props.selectedTerminal} `, {
            variant: "success",
          });
          props.closeDeleteTerminalDialog(true); 
          return;         
        }
        handleError(response.status);
      },
      () => {
        handleError();
      }
    );
  };

  const handleError = (statusCode) => {
    if (statusCode === 403) {
      return;
    }
    props.enqueueSnackbar(`Error deleting terminal ${props.selectedTerminal} `, {
      variant: 'error'
    });
    props.closeDeleteTerminalDialog();
  }; 

  return (
    <CustomConfirmationDialog
      title="Remove accessible terminal"
      cancelButtonLabel="Cancel"
      confirmButtonLabel="Remove"
      mode="danger"
      onConfirm={deleteTerminal}
      onCancel={props.closeDeleteTerminalDialog}
    >
      Are you sure you want to remove terminal {props.selectedTerminal} from
      Accessible terminals list?
    </CustomConfirmationDialog>
  );
}

export default DeleteDialog;
